export const SESSION_INFO_COMMAND = 'session.info';

export type SessionInfoResponse = {
    cmd: {
        success: boolean;
        params: SessionInfoResult
    }
}

export type ConnInfo = {
    protocol: string;
    remoteAddr: string;
}

export type OrgProfileSettings = {
    maxRetention: number;
    enCloudTriggers: boolean;
    enCampaigns: boolean;
    enCdpAccess: boolean;
    enEuicc: boolean;
    enEuiccAdvanced: boolean;
    disableMgmtPortal: boolean;
    disableCustObjDefs: boolean;
    disableEsimLifecycleManagement?: boolean;
}

export interface SessionInfoResult {
    id: string;
    ref: string;
    serverId: string;
    orgId: string;
    orgKey: string;
    userId: string;
    userName: string;
    whoAmI: string;
    ipAddress: string;
    hasSuperAdmin: boolean;
    hasSuperOps: boolean;
    hasOrgAdmin: boolean;
    connInfo: ConnInfo;
    ttl: number;
    locale: string;
    allowSubOrgAccess?: any;
    startTime: Date;
    lastAccessed: Date;
    mustResetPassword: boolean;
    allAgreementsSigned: boolean;
    orgProfileSettings: OrgProfileSettings;
    perms: string[];
    support: boolean;
}
